import { type ReactElement } from 'react';
import { useDeleteAccountPanel } from '@/features/users/hooks/useDeleteAccountPanel';
import { usePasswordChangeForm } from '@/features/users/hooks/usePasswordChangeForm';
import { useUserProfileForm } from '@/features/users/hooks/useUserProfileForm';
import { layoutModeTokens, useLayoutMode } from '@/ui/layouts/layoutMode';
import { UserSettingsScreen } from './UserSettingsScreen';
import type { AuthSession } from '@/auth/types';

type UserSettingsPageProps = { session: AuthSession | null };

export const UserSettingsPage = ({ session }: UserSettingsPageProps): ReactElement => {
  const layoutMode = useLayoutMode();
  const fieldDirection = layoutMode === layoutModeTokens.compact ? 'column' : 'row';
  const profileModel = useUserProfileForm(session);
  const passwordModel = usePasswordChangeForm({
    session,
    refreshUser: profileModel.refreshUser,
    externalAuthProvider: profileModel.state.externalAuthProvider,
  });
  const deleteAccount = useDeleteAccountPanel();
  return (
    <UserSettingsScreen
      profile={profileModel.state}
      userDetailError={profileModel.userDetailError}
      password={passwordModel}
      deleteAccount={deleteAccount}
      fieldDirection={fieldDirection}
      session={session}
    />
  );
};
